export const BASE_URL = import.meta.env.VITE_DATASERVICE;
// export const IS_CYPRESS = !!(window as any).Cypress;
export const IS_CYPRESS = false;
export const IS_TEST = import.meta.env.NODE_ENV === "test";
export const IS_DEVELOPMENT = import.meta.env.NODE_ENV === "development";
export const IS_TEST_OR_DEVELOPMENT = ["development", "test"].includes(import.meta.env.NODE_ENV);
export const DEPLOYMENT_ENV = import.meta.env.VITE_DEPLOYMENT_ENV;
export const IS_DEPLOYMENT_ENV_PROD = import.meta.env.VITE_DEPLOYMENT_ENV === "production";
export const IS_DEPLOYMENT_ENV_STAGING = import.meta.env.VITE_DEPLOYMENT_ENV === "staging";
export const IS_DEPLOYMENT_ENV_TEST = import.meta.env.VITE_DEPLOYMENT_ENV === "test";
export const IS_LOCAL = import.meta.env.VITE_MODE_LOCAL === "true";
export const IS_HEADLESS = import.meta.env.VITE_MODE_HEADLESS === "true";
export const SUB_ENV = import.meta.env.VITE_SUB_ENVIRONMENT;

export const DOCS_URL = import.meta.env.VITE_DOCS;
export const OPENAPI_URL = import.meta.env.VITE_OPENAPI;
export const MARKETING_URL = import.meta.env.VITE_MAIN_URL;
export const STATUS_URL = import.meta.env.VITE_STATUS_URL;

export const IS_HUBSPOT_INTEGRATION_ENABLED = import.meta.env.VITE_ENABLE_HUBSPOT_INTEGRATION === "true";
export const HUBSPOT_SERVICE_URL = import.meta.env.VITE_HUBSPOT_SERVICE;
export const REFERRAL_SERVICE_PARTNER_URL = import.meta.env.VITE_REFERRAL_SERVICE_PARTNER;
export const MARKETPLACE_SERVICE_URL = import.meta.env.VITE_MARKETPLACE_SERVICE;
export const MARKETPLACE_TEMPLATE_REPO = import.meta.env.VITE_MARKETPLACE_TEMPLATE_REPO;
export const MARKETPLACE_BRANCH = import.meta.env.VITE_MARKETPLACE_BRANCH;
export const IS_SENTRY_ENABLED = import.meta.env.VITE_SENTRY_ENABLE === "true";

export const DEPLOYMENT_UPDATE_INTERVAL_MS = Number(import.meta.env.VITE_DEPLOYMENT_UPDATE_INTERVAL_MS);
export const KUBERNETES_READINESS_UPDATE_INTERVAL_MS = Number(
  import.meta.env.VITE_KUBERNETES_READINESS_UPDATE_INTERVAL_MS,
);
export const DOMAIN_UPDATE_INTERVAL_MS = Number(import.meta.env.VITE_DOMAIN_UPDATE_INTERVAL_MS);
export const TOKEN_EXP_CHECK_INTERVAL_MS = Number(import.meta.env.VITE_TOKEN_EXP_CHECK_INTERVAL_MS);
export const METRICS_TOKEN_UPDATE_INTERVAL_MS = Number(import.meta.env.VITE_METRICS_TOKEN_UPDATE_INTERVAL_MS);
export const MK8S_DASHBOARD_TOKEN_UPDATE_INTERVAL_MS = Number(
  import.meta.env.VITE_MK8S_DASHBOARD_TOKEN_UPDATE_INTERVAL_MS,
);
export const REQUEST_REPLICAS_INTERVAL_MS = Number(import.meta.env.VITE_REQUEST_REPLICAS_INTERVAL_MS);
export const VERSION_CHECK_INTERVAL_MS = Number(import.meta.env.VITE_VERSION_CHECK_INTERVAL_MS);
export const AGENT_UPDATE_INTERVAL_MS = Number(import.meta.env.VITE_AGENT_UPDATE_INTERVAL_MS);
export const MK8S_NODE_STATUS_INTERVAL_MS = Number(import.meta.env.VITE_MK8S_NODE_STATUS_INTERVAL_MS) || 30000;
export const ALL_DOMAINS_UPDATE_INTERVAL_MS = Number(import.meta.env.VITE_ALL_DOMAINS_UPDATE_INTERVAL_MS);
export const COMMANDS_INTERVAL_MS = Number(import.meta.env.VITE_COMMANDS_INTERVAL_MS);
export const VOLUMESET_UPDATE_INTERVAL_MS = Number(import.meta.env.VITE_VOLUMESET_UPDATE_INTERVAL_MS);

export const STORAGE_KEY_LOG_ORDER_BY: string = import.meta.env.VITE_STORAGE_KEY_LOG_ORDER_BY as string;
export const STORAGE_KEY_LOG_TABLE_TIMESTAMP: string = import.meta.env.VITE_STORAGE_KEY_LOG_TABLE_TIMESTAMP as string;
export const STORAGE_KEY_LOG_TABLE_LABELS: string = import.meta.env.VITE_STORAGE_KEY_LOG_TABLE_LABELS as string;
export const STORAGE_KEY_LOG_TABLE_WRAPPED_LINES: string = import.meta.env
  .VITE_STORAGE_KEY_LOG_TABLE_WRAPPED_LINES as string;
export const STORAGE_KEY_LOG_TABLE_PRETTIFY_JSON: string = import.meta.env
  .VITE_STORAGE_KEY_LOG_TABLE_PRETTIFY_JSON as string;
export const STORAGE_KEY_LOGGED_OUT_STATE = "LOGGED_OUT_STATE";
export const STORAGE_KEY_LAST_ACTIVITY = "LAST_ACTIVITY";
export const STORAGE_KEY_ORG_TIMEOUT_SECONDS = "ORG_TIMEOUT_SECONDS";
export const STORAGE_KEY_ACCOUNT_EXTERNAL_ID = "ACCOUNT_EXTERNAL_ID";
export const STORAGE_KEY_CAPTURED_COOKIE = "CAPTURED_COOKIE";
export const STORAGE_KEY_GUIDE_LEGACY = "GUIDE_LEGACY";
export const STORAGE_KEY_GUIDE_CONTEXT = "GUIDE_CONTEXT";
export const STORAGE_KEY_GUIDE_ACCOUNT_ORG = "GUIDE_ACCOUNT_ORG";
export const STORAGE_KEY_GUIDE_LIMIT_BY_CONTEXT = "GUIDE_LIMIT_BY_CONTEXT";
export const STORAGE_KEY_VIEW_MODAL_SLIM = "VIEW_MODAL_SLIM";

export const SHOW_LEGACY_NEW_SWITCH = import.meta.env.VITE_SHOW_LEGACY_NEW_SWITCH === "true";
export const MODE_VARIATION = import.meta.env.MODE_VARIATION;

export const DEVELOPMENT_CONSOLE_MODE = import.meta.env.VITE_DEVELOPMENT_CONSOLE_MODE;
export const DEVELOPMENT_LEGACY_URL = import.meta.env.VITE_DEVELOPMENT_LEGACY_URL;
export const STAGING_CONSOLE_MODE = import.meta.env.VITE_STAGING_CONSOLE_MODE;
export const STAGING_LEGACY_URL = import.meta.env.VITE_STAGING_LEGACY_URL;
export const PRODUCTION_CONSOLE_MODE = import.meta.env.VITE_PRODUCTION_CONSOLE_MODE;
export const PRODUCTION_LEGACY_URL = import.meta.env.VITE_PRODUCTION_LEGACY_URL;

export const CONSOLE_URL = import.meta.env.VITE_CONSOLE; // self
export const CONSOLE_BASE = import.meta.env.VITE_CONSOLE_BASE; // no variation

if (IS_DEVELOPMENT) {
  console.info("env", import.meta.env);
}
